import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ProductionScheduleItemInPathGroup} from '@domain/production-schedule/production-schedule-item-in-path-group';
import {ProductionSchedulePath} from '@domain/production-schedule/production-schedule-path';
import {ProductionSchedulePathsOfColoredYarnSet} from '@domain/production-schedule/production-schedule-paths-of-colored-yarn-set';
import {ArrayUtils, AssertionUtils} from '@vdw/angular-component-library';

export function updateProductionSchedulePathsOfColoredYarnSets(productionSchedule: ProductionSchedule): ProductionSchedule {
  productionSchedule.productionSchedulePathsOfColoredYarnSets.forEach((productionSchedulePathsOfColoredYarnSet: ProductionSchedulePathsOfColoredYarnSet, indexOfColoredYarnSet: number) => {
    productionSchedulePathsOfColoredYarnSet.productionSchedulePaths.forEach((productionSchedulePath: ProductionSchedulePath, index: number) => {
      if (!AssertionUtils.isNullOrUndefined(productionSchedulePath.pathGroups) && !AssertionUtils.isEmpty(productionSchedulePath.pathGroups)) {
        productionSchedulePath.technicalWidthInDents = ArrayUtils.convertFalsyValuesToZeroAndGetMaxValue(
          Array.from(productionSchedulePath.pathGroups, (productionScheduleItemInPathGroup: ProductionScheduleItemInPathGroup) => productionScheduleItemInPathGroup.technicalDimensions.widthInDents)
        );
      }

      productionSchedulePath.commercialWidthInMM = ArrayUtils.convertFalsyValuesToZeroAndGetMaxValue(
        Array.from(productionSchedulePath.pathGroups, (productionScheduleItemInPathGroup: ProductionScheduleItemInPathGroup) =>
          !AssertionUtils.isNullOrUndefined(productionScheduleItemInPathGroup.commercialDimensionsInMM) ? productionScheduleItemInPathGroup.commercialDimensionsInMM.widthInMM : 0
        )
      );

      const isFirstPathOfProductionSchedule: boolean = indexOfColoredYarnSet === 0 && index === 0;
      if (isFirstPathOfProductionSchedule) {
        productionSchedulePath.startDent = 1;
      } else {
        const isFirstPathOfColoredYarnSet: boolean = index === 0;
        if (isFirstPathOfColoredYarnSet) {
          const previousProductionScheduleColoredYarnSetPath = productionSchedule.productionSchedulePathsOfColoredYarnSets[indexOfColoredYarnSet - 1];
          productionSchedulePath.startDent =
            previousProductionScheduleColoredYarnSetPath.productionScheduleColoredYarnSet.startDent +
            previousProductionScheduleColoredYarnSetPath.productionScheduleColoredYarnSet.technicalWidthInDents;
        } else {
          const previousProductionSchedulePath: ProductionSchedulePath = productionSchedulePathsOfColoredYarnSet.productionSchedulePaths[index - 1];
          productionSchedulePath.startDent = previousProductionSchedulePath.startDent + previousProductionSchedulePath.technicalWidthInDents;
        }
      }
    });
  });

  return productionSchedule;
}
